/* eslint-disable */
import React from 'react';
import HeaderPage from './PrintHeaderPage';
import PrintButton from '@/print-pdf/PrintButton';
import Voca from 'voca';

const parsePrettyNumber = number => number.toLocaleString('en-US', {
    minimumIntegerDigits: 2,
    useGrouping: true
});

const ColorRow1 = report => {


    let color = 'white';

    // if (report.total_delinquent > 750) {
    if (report.total_delinquent > 1000) {
        //yellow
        color = '#ffd599';
    }
    if (report.data.special_status === 'NSF') {
        //green
        color = '#b7dfb9';
    }
    if (report.data.special_status === 'Section 8') {
        //purple
        color = '#d983e4';
    }
    if (report.data.special_status === 'Adjustment') {
        //blue
        color = '#B7D5F4';
    }
    if (report.data.special_status === 'Repayment Agreement') {
        //lightGreen
        color = '#88e27cbf';
    }
    if (report.data.special_status === 'Employee') {
        //lightBlue
        color = '#a5eff1bf';
    }
    if (report.data.special_status === 'Govt. Assistance') {
        //orange
        color = '#e4b152bf';
    }
    if (/eviction/i.test(report.lease_status)) {
        //red
        color = '#fab3ae';
    }

    if (!!report.data.initial_payment || !!report.data.balance || !!report.data.stipulation_signed_date || report.active_repayment_agreement !== "No") {
        //grey
        color = '#9e9e9ebf';
    }

    return color;
};

export const PrintDocument = props => {

    const {
        data,
        propertyName,
        dataBuildingOccupancy,
        totalDelinquentForProperty,
        totalDelinquentForExictions,
        counts,
        adminOrLegal
    } = props;

    const headers = {
        // color: {
        //     columnName: ' ',
        //     style: {
        //         maxWidth: 8,
        //         borderWidth: 0
        //     }
        // },
        bldg_unit: {
            columnName: 'Unit #',
            style: {
                maxWidth: 40
            }
        },
        resident_name: {
            columnName: 'Resident Name',
            style: {
                maxWidth: 120,
                marginLeft: '0px'
            }
        },
        lease_status: {
            columnName: 'Lease Status',
            style: {
                maxWidth: 150,
                marginLeft: '0px'
            }
        },
        total_delinquent: {
            columnName: 'Total Delinquent',
            style: {
                maxWidth: 75,
                marginLeft: '0px'
            }
        },
        manager_notes: {
            columnName: 'Manager Notes',
            style: {
                maxWidth: 180,
                marginLeft: '0px'
            }
        },
        scheduled_rent: {
            columnName: 'Sched Rent',
            style: {
                maxWidth: 28,
                marginLeft: '0px',
                textAlign: 'center'
            }
        },
        hold_date: {
            columnName: 'Hold Date',
            style: {
                maxWidth: 30,
                marginLeft: '0px'
            }
        },
        held_by: {
            columnName: 'Held By',
            style: {
                maxWidth: 30,
                marginLeft: '0px'
            }
        },
        general_notes: {

            columnName: 'General Notes',
            style: {
                maxWidth: 180,
                marginLeft: '0px'
            }
        },
        admin_notes: {

            columnName: 'Admin Notes',
            style: {
                maxWidth: 180,
                marginLeft: '0px'
            }
        }
    };

    if (!adminOrLegal) {
        delete headers.admin_notes;
    }


    /**
     * row = { [key]: value }
     */

    const rows = data.map(row => {

        /** row = { [key]: { value } } */
        const transformedRow = Object.fromEntries(
            Object.entries(row).map(
                ([key, text]) => [key, {
                    text,
                    ...(headers[key]?.style || {})
                }]
            )
        );

        // tansform
        const total_delinquent = [];
        total_delinquent.push(`Current due:${ row.total_current_due}`);
        total_delinquent.push(`Past due:${ row.total_past_due}`);
        total_delinquent.push(`Total del:${ parsePrettyNumber(row.total_delinquent)}`);

        transformedRow.total_delinquent = {
            ...(headers.total_delinquent?.style || {}),
            text: total_delinquent
        };

        transformedRow.manager_notes = {
            ...(headers.manager_notes?.style || {}),
            text: row.data.manager_notes?.toLowerCase().slice(0, 85)
        };

        transformedRow.hold_date = {
            ...(headers.hold_date?.style || { }),
            text: row.data.hold_date
        };

        transformedRow.held_by = {
            ...(headers.held_by?.style, { }),
            text: row.data.held_by
        };

        transformedRow.general_notes = {
            ...(headers.general_notes?.style || {}),
            text: row.data.general_notes?.toLowerCase().slice(0, 85)
        };

        if (adminOrLegal){
            transformedRow.admin_notes = {
                ...(headers.admin_notes?.style || {}),
                text: row.data.admin_notes?.toLowerCase().slice(0, 85)
            };
        }

        transformedRow.color = {
            ...(headers.color?.style || {}),
            text: '',
            backgroundColor: ColorRow1(row)
        };

        transformedRow.bldg_unit = {
            ...(headers.bldg_unit?.style || {}),
            text: row.bldg_unit
            //backgroundColor: ColorRow1(row)
        };

        transformedRow.resident_name = {
            ...(headers.resident_name?.style || {}),
            text: Voca.titleCase(row.resident_name)
            //backgroundColor: ColorRow1(row)
        };

        const lease_status = [];
        lease_status.push(row.lease_status);
        if (row.data.special_status){
            lease_status.push(`Special-status:${ row.data.special_status}`);
        }
        else {
            lease_status.push('Special-status:-');
        }
        if (row.lease_sub_status){
            lease_status.push(`Sub-Status:${ row.lease_sub_status}`);
        }
        else {
            lease_status.push('Sub-Status:-');
        }

        transformedRow.lease_status = {
            ...(headers.lease_status?.style || {}),
            text: lease_status
            //backgroundColor: ColorRow1(row)
        };

        delete transformedRow.data;
        delete transformedRow.lease_sub_status;

        return transformedRow;
    });

    return (
        <PrintButton
            orientation = { 'landscape' }
            headers={headers}
            data={rows}
            rowsPerPage={15}
            HeaderPage={() => (<HeaderPage
                property_name={propertyName}
                totalDelinquentForProperty={totalDelinquentForProperty}
                totalDelinquentForExictions={totalDelinquentForExictions}
                counts={counts}
                dataBuildingOccupancy={dataBuildingOccupancy}
            />)}
        />
    );
};
